import { render, staticRenderFns } from "./VerPrograma.vue?vue&type=template&id=a8d5ef2c&scoped=true&"
import script from "./VerPrograma.vue?vue&type=script&lang=js&"
export * from "./VerPrograma.vue?vue&type=script&lang=js&"
import style0 from "./VerPrograma.vue?vue&type=style&index=0&id=a8d5ef2c&scoped=true&lang=css&"
import style1 from "./VerPrograma.vue?vue&type=style&index=1&id=a8d5ef2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d5ef2c",
  null
  
)

export default component.exports